<script>
import AddNewOfficeHours from "./AddNewOfficeHours.vue";
import AddButton from "../../../components/buttons/AddButton.vue";
import NormalButton from "../../../components/buttons/NormalButton.vue";
import SpinnerLoader from "../../../components/loaders/SpinnerLoader.vue";
import axios from "axios";

export default {
    components: { AddNewOfficeHours, AddButton, NormalButton, SpinnerLoader },
    props: {
        userOfficeHoursDetails: {
            type: Array,
            required: true,
            default: [],
        },
    },
    data() {
        return {
            defaultOptions: [
                { name: "Everyday" },
                { name: "Monday" },
                { name: "Tuesday" },
                { name: "Wednesday" },
                { name: "Thursday" },
                { name: "Friday" },
                { name: "Saturday" },
                { name: "Sunday" },
            ],
            allItems: [],
            errors: {},
            disabledDiscardButton: true,
            disabledSaveButton: true,
            isPageLoading: false,
        };
    },
    methods: {
        addNewItem() {
            const now = new Date();
            const hours = String(now.getHours()).padStart(2, "0");
            const minutes = String(now.getMinutes()).padStart(2, "0");
            let lastIndex = 0;
            if (this.allItems.length) {
                this.allItems.map((item) => {
                    lastIndex = item.index;
                    lastIndex += 1;
                });
            }
            this.allItems.push({
                id: null,
                index: lastIndex,
                day: [],
                from_time: `${hours}:${minutes}:00`,
                to_time: `${hours}:${minutes}:00`,
            });
            this.onAnyChanges();
        },
        discardChanges() {
           this.refreshRoute()
        },
        refreshRoute() {
            this.$inertia.visit(
                route(`${this.userTypeAbbr}-office-hours-management`),
                {
                    method: "get",
                }
            );
        },
        saveChanges() {
            this.isPageLoading = true;
            axios
                .post(
                    route(this.userTypeAbbr + "-office-hours-update"),
                    { allItems: this.allItems },
                    {}
                )
                .then((response) => {
                    if (response.data.success) {
                        this.$toastr.s(response.data.message);
                        setTimeout(() => {
                            this.refreshRoute();
                        }, 200);
                    }
                })
                .catch((err) => {
                    if (err.response.status === 422) {
                        this.errors = err.response.data.errors;
                        if (this.errors.hasOwnProperty("allItems")) {
                            this.$toastr.e(this.errors["allItems"]);
                        }
                    } else {
                        this.$toastr.e(err.response.data.message);
                    }
                });
            this.isPageLoading = false;
        },
        onAnyChanges() {
            this.disabledDiscardButton = false;
            this.disabledSaveButton = false;
            this.errors = {}
        },
        handleDaysChange(item, index, type) {
            this.onAnyChanges();
            this.allItems = this.allItems.map((data, i) => {
                if (i == index) {
                    let selected = { ...data };
                    if (type === "select") {
                        selected.day = [...selected.day, item];
                    } else {
                        selected.day = selected.day.filter(
                            (remove) => remove.name !== item.name
                        );
                    }
                    return selected;
                }
                return data;
            });
        },
        handleTimeChange(item, index, type) {
            this.onAnyChanges();
            this.allItems = this.allItems.map((data, i) => {
                if (i == index) {
                    let selected = { ...data };
                    if (type === "from_time") {
                        selected.from_time = item;
                    } else {
                        selected.to_time = item;
                    }
                    return selected;
                }
                return data;
            });
        },
        deleteItems(index) {
            if (this.allItems.length > 1) {
                this.allItems.splice(index, 1);
                this.onAnyChanges();
            } else {
                this.$toastr.e("Unable to delete! Please add one more item.");
            }
        },
        checkErrors(key) {
            if (this.errors.hasOwnProperty(key)) return this.errors[key];
            else return null;
        },
    },
    computed: {
        // Example admin, sb, tc, tp
        userTypeAbbr() {
            return this.$page.props.auth.user.user_type_abbr;
        },
        filteredOptions() {
            let daysSelected = [];
            this.allItems.map((item) => {
                daysSelected = [
                    ...daysSelected,
                    ...item.day.map((item) => item.name),
                ];
            });
            //All days of the week except Everyday
            const specificDaysSelected = daysSelected.some(
                (day) => day !== "Everyday"
            );
            return this.defaultOptions.filter((option) => {
                return !(
                    (specificDaysSelected && option.name === "Everyday") ||
                    daysSelected.includes(option.name) ||
                    daysSelected.includes("Everyday")
                );
            });
        },
        closedDays() {
            const days = this.filteredOptions
            if (days.length) {
                const daysNames = days.map(day => {
                    if (day.name !== 'Everyday')
                        return day.name;
                }).filter(Boolean);

                return daysNames.length ? daysNames.join(', ') : 'N/A';
            } else {
                return 'N/A';
            }
        }
    },
    beforeMount() {
        if (!this.userOfficeHoursDetails.length) {
            this.addNewItem();
        } else {
            this.isPageLoading = true;
            this.userOfficeHoursDetails.map((item, i) => {
                this.allItems = [...this.allItems, item];
            });
            this.isPageLoading = false;
        }
        this.disabledDiscardButton = true;
        this.disabledSaveButton = true;
    },
};
</script>

<template>
    <div>
        <div v-if="!isPageLoading" class="minVh d-flex flex-column gap-3">
            <div>
                <span class="text-danger fw-bold">Closed Days:</span> 
                <span class="fst-normal text-danger">{{ closedDays }}</span>
            </div>
            <AddNewOfficeHours
                v-for="(officeHourItem, index) in allItems"
                :officeHourItem="officeHourItem"
                :options="filteredOptions"
                :handleDaysChange="handleDaysChange"
                :handleTimeChange="handleTimeChange"
                :deleteItems="deleteItems"
                :checkErrors="checkErrors"
                :index="index"
                :key="officeHourItem.index"
            />
            <div
                class="mt-auto d-flex justify-content-between align-items-center flex-nowrap"
            >
                <div class="d-flex justify-content-start">
                    <AddButton
                        :onClick="addNewItem"
                        :disabled="filteredOptions.length <= 0"
                    >
                        Add New
                    </AddButton>
                </div>
                <div class="d-flex justify-content-end">
                    <NormalButton
                        :onClick="discardChanges"
                        :disabled="disabledDiscardButton"
                        classes="btn btn-danger me-2"
                    >
                        Discard Changes
                    </NormalButton>
                    <NormalButton
                        :onClick="saveChanges"
                        :disabled="disabledSaveButton"
                        classes="btn btn-success"
                    >
                        Save Changes
                    </NormalButton>
                </div>
            </div>
        </div>
        <div class="d-flex align-items-center justify-content-center" v-else>
            <SpinnerLoader
                classes="spinner-border text-success"
                role="status"
                title="Loading..."
            />
        </div>
    </div>
</template>

<style scoped>
.minVh {
    min-height: calc(100vh - 30vh);
}
</style>
